// note: do NOT rely on `import *`. the order the epics are added matters and can mess up epic chains

import { combineEpics } from 'redux-observable';

import { validateAddressOrderDetails, updateOrderAfterAddressValidation, validateAddressSalesOrderShipToFailure } from './address/epics';
import { updatePusherWhenFeatureFlagsChange } from './feature-flags/redux/epics';
import { updateFulfillmentPlanOrderGridStatus } from './fulfillment-plans/epics';
import { updateShipTo, updateShipToAndSoldTo } from './orders/epics';
import { onExportTransactionHistoryExportRequest } from './pages/settings/transaction-history/transaction-history.epics';
import {
  getShipmentSuccess,
  verifyShipmentRequest,
  editVerifiedItems,
  setVerificationStatus,
  popUpVerificationToast,
  popUpVerificationErrorToast,
} from './scan/verify/store/scan-to-verify.epics';
import { getAccountInformationEpic } from './store/account-information/account-information.epics';
import { dropinEpic, endDropin } from './store/admin/admin.epics';
import { syncProductsStart } from './store/advanced-shipping-notices/advanced-shipping-notices.epics';
import { getMoreOrderAlertsEpic } from './store/alerts/alerts.epics';
import {
  getAlertDetailsEpic,
  getShipTogetherOrdersEpic as getShipTogetherOrdersEpicFromAlerts,
} from './store/alerts/details/alerts.details.epic';
import {
  alertsShipTogetherFetchEpic,
  respondToAlertsPageEvents,
  alertsDismissalEpic,
  getShipTogetherOrdersEpic,
  shipTogetherFromAlertsEpic,
  shipTogetherSuccessNotificationEpic,
  getOrdersForSelectedAlertsEpic,
  getOrdersForAlertSelectionEpic,
} from './store/alerts/grid/alerts.grid.epics';
import { ordersViewsChangedEpic } from './store/alerts/nav/alerts.nav.epics';
import { getAnnouncments, displayNotificationsForAnnouncements } from './store/announcements/announcements.epics';
import { launchEnterpriseChat } from './store/app-header/app-header.epics';
import {
  createBatch,
  createBatchWithSalesOrdersRequest,
  addFulfillmentPlanOrSalesOrderToBatchRequest,
  saveBatchesEpic,
  cancelBatchEpic,
  saveBatchNameChange,
  createBatchWithFulfillmentPlanRequest,
  onCreateBatchWithSalesOrdersRequestSuccess,
  onCreateBatchWithFulfillmentPlansRequestSuccess,
  forceAddToBatch,
  onSalesOrderFulfillmentPlansRejectedFromBatchEpic,
} from './store/batches/batches.epic';
import {
  getBatchDetailsEpic,
  validateBatchAddressesEpic,
  getBatchFulfillmentPlansForGridEpic,
  getBatchOrdersShipmentsMode,
  removedFulfillmentPlansFromBatchEpic,
  closeMoveToBatchModalEpic,
  batchValidationCompletedEpic,
  rateBatchCompletedEpic,
  rateOpenedOrderFromBatchEpic,
  sendShipmentNotificationsEpic,
  shipmentNotificationPusherMessageEpic,
  shipmentNotificationsSentSuccessfullyEpic,
  shipmentNotificationsSentFailureEpic,
  refreshBatchDetails,
} from './store/batches/details/batch.details.epic';
import {
  batchRowsGet,
  batchRowLoad,
  archiveBatches,
  validateBatchesAddressesEpic,
  sendEmailForBatchesEpic,
  sendNotificationsForBatchesEpic,
  updateSearchTermFromGridEpic,
} from './store/batches/grid/batches.grid.epic';
import {
  getLabelQueBatchWarnAndError,
  handleGeneralLabelQueExceptionEpic,
  retryBatchForWarnAndErrorEpic,
} from './store/batches/label-batch-status-modal/batches.label-batch-status-modal.epics';
import {
  batchesUpdateShippingPageLeftNav,
  ordersViewsChanged,
  getBatchesMenuDataEpic,
  createLabelLastMessageBatchLoad,
} from './store/batches/nav/batches.nav.epics';
import { saveOrEditBatchNoteRequestEpic } from './store/batches/notes/batch-note.epic';
import {
  checkForLabelPrintedEpic,
  printLabelEpic,
  checkForPackingSlipPrintedEpic,
  printPackingSlipEpic,
  labelBatchPrintOtherForms,
} from './store/batches/print/batches.print.epics';
import { startBatchesShipmentPurchase } from './store/batches/purchase/batches.purchase.epic';
import {
  openScanToBatchModal,
  scanToBatchFulFillmentPlanSearch,
  addFulfillmentPlansToBatchFromScan,
  scannedOrderIsInAnotherBatch,
  unableToMoveOrderToBatch,
  scannedOrderWasNotFound,
} from './store/batches/scan-to-batch/scan-to-batch.epics';
import { createLabelProcessing, refreshOrdersGridAfterCreateLabel } from './store/bulk/bulk.epics';
import { costReviewModal } from './store/bulk/cost-review/bulk.cost-review.epics';
import {
  startBulkPurchase as startBulkPurchaseFromPrint,
  startActiveLabelCheck,
  getLabelPrintedStatus,
  startPrintFlow,
  endBulkPrint,
} from './store/bulk/print/bulk.print.epics';
import { startBulkPurchase } from './store/bulk/purchase/bulk.purchase.epics';
import { bulkReshipStart } from './store/bulk/reship/bulk.reship.epics';
import { onJobStarted, onJobStartedFromDrawer, onDoNotNotifyMarketPlaceJobStarted } from './store/bulk/update/bulk.update.epics';
import {
  startBulkVoid,
  showBulkVoidConfirmation,
  sendBulkVoidRequest,
  launchBulkVoidResultsModal,
  bulkVoidRetry,
} from './store/bulk/void/bulk.void.epics';
import { getFulfillmentPlansBulkloadData, getSalesOrdersBulkloadData } from './store/bulkload/bulkload.epic';
import { getSharedServices } from './store/carrier-sharing/carrier-sharing.epic';
import { appInitialization, initializePusher } from './store/core/base.epics';
import { getSellerRecommendations } from './store/seller-recommendations/seller-recommendations.epic';
import {
  configureLabel,
  createLabel,
  endProcessingCreateLabel,
  createLabelFailure,
} from './store/create-label-content/create-label-content.epics';
import { notifyAboutFinishedImport } from './store/csv-import/csv-import.epic';
import {
  initCsw,
  createLabel as createLabelFromCSW,
  createLabelFailure as createLabelFailureFromCSW,
  openPrintModalFromLabelSuccessEpic,
  changeInsuranceValue,
  getRateEpic,
  saveShippingConfigEpic,
  getBestWayToShip,
  changeServiceAndOtherShippingOptions,
  enterReturnsMode,
  enterExternalFulfillmentMode,
  createExternalFulfillment,
  showRateViewerErrors,
  createTestLabel,
  createTestLabelSuccess,
  saveShippingDropdownPreferenceToUserSettingsEpic,
  startUpdateAvailableShippingServices,
  fulfillmentPlannerGlobalListeners,
  cswCompareRates,
} from './store/csw/csw.epics';
import { customerSearchResultsEpic } from './store/customers/autocomplete/customers.autocomplete.epics';
import {
  prepareToOpenCombineCustomersModal,
  prepareToOpenCombineCustomersConfirmationModal,
  combineCustomers,
  closeCombineCustomersConfirmationModal,
  reorderSelectedCustomers,
} from './store/customers/combine/customers.combine.epic';
import { launchCustomerCreateLabelModal, closeCustomerCreateLabelModal } from './store/customers/create-label/customers.create-label.epics';
import {
  addTagsToCustomers,
  refreshCustomers,
  removeTagsFromCustomers,
  getCustomersRequest,
  changeCustomersPage,
  quickSearchForCustomers,
  setCustomColumnConfigurationOnFilterUpdate,
  launchCustomerDetailModal,
  getCustomerPreviousOrders,
  clearCustomersSearch,
  launchCustomerMarketplacesModal,
} from './store/customers/customers.epics';
import {
  updateGridWithNoFilters,
  switchActiveFilterView,
  getSavedFilterViewsRequest,
  saveNewFilterView,
  saveExistingFilterView,
  updateSavedViewGridConfig,
  deleteFilterView,
  launchSaveShippingViewModal,
  launchEditShippingViewModal,
  launchDeleteShippingViewModal,
} from './store/customers/filtering/customers.filtering.epics';
import {
  prepareToOpenImportCustomersModal,
  startImport,
  afterImportSuccess,
  afterImportFailure,
} from './store/customers/import/customers.import.epic';
import { customersGridRefresh } from './store/customers/nav/customers.nav.epics';
import { checkCustomsStatusForOrders, checkCustomsStatusForFulfillmentPlans } from './store/customs/customs.epics';
import { validateAndSave } from './store/customs-declarations/customs-declarations.epics';
import { orderToursEpic, openExistingDemoOrderEpic, deactivateDemoOrderEpic } from './store/demos/demos.epics';
import { printDocument, downloadDocument } from './store/documents/documents.epic';
import {
  bulkFetchOrderDetails,
  updateFulfillmentPlanNote,
  unlockAddress,
  unlockAddressFailure,
  dismissFraudIndicator,
} from './store/entities/entities.epics';
import { logFailureEpicsToSenty } from './store/error-logging/error-logging.epics';
import {
  openExportShipmentsModalEpic,
  initiateOrdersExportEpic,
  initiateOrdersCustomExportEpic,
  downloadOrdersExportEpic,
} from './store/export/orders/export-orders.epics';
import {
  openExportShipmentsModalEpic as openExportShipmentsModalEpicFromExportShipments,
  openExportBatchShipmentsModalEpic,
  initiateShipmentExportEpic,
  initiateBatchShipmentExportEpic,
  initiateShipmentsCustomExportEpic,
  downloadShipmentsExportEpic,
} from './store/export/shipments/export-shipments.epics';
import {
  handleReceivedPusherMessage,
  onExportFulfillment,
  onExportFulfillmentExtended,
  onCustomExportFulfilments,
} from './store/external-fulfillments/external-fulfillments.epics';
import { getFillProviders } from './store/fill-providers/fill-providers.epics';
import { launchHoldUntilModal, launchRemoveHoldModal } from './store/hold-until/hold-until.epic';
import { persistNotificationEpic } from './store/notification-hub/notification-hub.epic';
import { fetchNotificationsEpic, markAsReadEpic, markAllAsReadEpic } from './store/notification-hub/notification-hub.epics';
import {
  getCarrierDocumentCapabilitiesEpic,
  getOrderDocumentsEpic,
  uploadOrderDocumentEpic,
  deleteOrderDocumentEpic,
  getShipmentDocumentsEpic,
  uploadShipmentDocumentEpic,
  deleteShipmentDocumentEpic,
  sendShipmentDocumentsEpic,
  savePendingDocumentConfigEpic,
} from './store/customs-documents/customs-documents.epics';
import {
  getStockLevelDetails,
  getStockLevelDetailsOnGetOrderDetailsSuccess,
  getStockLevelDetailsOnShipFromChange,
  getStockLevelDetailsOnAllocationOrDeallocationSuccess,
  allocate,
  allocateFromOrderDetails,
  allocateFromShipmentDetails,
  allocateFromOrderDetailsCsw,
  allocateFromPrintModal,
  allocateSelectedFulfillmentPlansFromOrdersGrid,
  allocateFulfillmentPlansFailure,
  deallocate,
  deallocateSilently,
  deallocateOnShipFromChange,
  exportInventoryRequest,
  exportLocationsInventoryRequest,
  exportTotesRequest,
  importInventoryRequest,
  getProductImportLog,
  reloadInventoryGrid,
} from './store/inventory/inventory.epics';
import {
  startJobPipeline,
  runPipelineStepForJob,
  handleCurrentPipelineIndexChanged,
  exitPipeline,
} from './store/job-pipeline/job-pipeline.epics';
import {
  getLabelQueBatchesEpic,
  labelQueArchiveBatches,
  getLabelQueBatchWarnAndError as getLabelQueBatchWarnAndErrorFromLabelQueue,
  beginLabelQueBatchPackingSlipPrintingEpic,
  beginBatchQueLabelPrintingEpic,
  labelQuePrintPickListEpic,
  labelQuePrintShipmentManifestEpic,
  labelQuePrintOrderSummaryEpic,
  handleGeneralLabelQueExceptionEpic as handleGeneralLabelQueExceptionEpicFromLabelQueue,
  retryBatchForWarnAndErrorEpic as retryBatchForWarnAndErrorEpicFromLabelQueue,
} from './store/label-que/label-que.epics';
import { launchVoidModal, acceptWarningAndVoid, voidLabels } from './store/labels/labels.epics';
import {
  markAsShippedEpic,
  refreshGridAfterSuccessfullyMarkingOrdersOrShipmentsAsShipped,
  showThatAnErrorHappened,
  undoMarkAsShippedEpic,
  undoMarkAsShippedFromOrderDetails,
  undoMarkAsShippedSuccessEpic,
} from './store/mark-as-shipped/mark-as-shipped.epics';
import { oneTimeReadScaleRequestEpic } from './store/one-time-scale/one-time-scale.epics';
import {
  selectOrdersEpic,
  loadOrderDrawerEpic,
  clearDrawerErrorsAndWarnings,
  getDrawerOrdersEpic,
  validateAddress,
  updateDrawerOrdersAfterAddressValidation,
  refreshDrawer,
  bulkApplyRecommendations,
} from './store/orders/drawer/orders.drawer.epics';
import {
  prepareToOpenNewOrderModal,
  openNewOrderModal,
  onChangesSaved,
  onSaveNewOrder,
  openCancelOrderModal,
} from './store/orders/edit-order/edit.order.epics';
import {
  updateGridWithNoFilters as updateGridWithNoFiltersFromOrdersFilteringEpics,
  switchActiveFilterView as switchActiveFilterViewFromOrdersFilteringEpics,
  getSavedFilterViewsRequest as getSavedFilterViewsRequestFromOrdersFilteringEpics,
  saveNewFilterView as saveNewFilterViewFromOrdersFilteringEpics,
  saveExistingFilterView as saveExistingFilterViewFromOrdersFilteringEpics,
  updateSavedViewGridConfig as updateSavedViewGridConfigFromOrdersFilteringEpics,
  deleteFilterView as deleteFilterViewFromOrdersFilteringEpics,
  launchSaveOrdersViewModal,
  launchEditOrdersViewModal,
  launchDeleteOrdersViewModal,
} from './store/orders/filtering/orders.filtering.epics';
import {
  changeOrderBy,
  orderGridAddressValidation,
  openMarkShippedModal,
  setCustomColumnConfigurationOnFilterUpdate as setCustomColumnConfigurationOnFilterUpdateFromOrdersGridEpics,
  getRatesFromGridEpic,
  getRatesForGridRequestEpic,
  getRatesFromGridFailureEpic,
  addSalesOrderToBatchFromGridEpic,
  openAddSalesOrderToBatchFromGridEpic,
  saveDrawerVisbilityUserSetting,
} from './store/orders/grid/orders.grid.epics';
import {
  getMappings,
  openOrderImportMappingsModal,
  openMappingsDeleteModal,
  deleteSavedMapping,
  upload,
  afterUploadSuccess,
  openMappingsManagerModal,
  startFileImport,
  openImportProgressNotification,
  renameSavedMapping,
  afterStoreUpdate,
  afterImportLogSuccess,
} from './store/orders/import/orders.import.epics';
import { quickSearchFromScanToSearchEpic, ordersGetCountsEpic } from './store/orders/nav/orders.nav.epics';
import {
  getOrderDetailsEpic,
  getOrderDetailsSilentlyEpic,
  openOrderDetailsModal,
  closeOrderDetailsModal,
  refreshGridAndOrderDetailsAfterOrderUpdate,
  goToOrderDetails,
  setSelectedReturnItems,
  exitReturnsMode,
  makeCreateAnotherShipmentSucess,
  addSalesOrderToBatchEpic,
  updateOrderItemsRequest,
  updateOrderDetailsOrderItemsOnSuccess,
} from './store/orders/order-details/orders.details.epics';
import {
  getOrderDataEpic,
  changeOrdersPage,
  createOrderEpic,
  markAsPaidEpic,
  addTagsToFulfillmentPlans,
  removeTagsFromFulfillmentPlans,
  quickSearchForOrders,
  ordersSearchTermCount,
  restoreOrder,
  restoreFulfillments,
  clearGridSelections,
  refreshGrid,
  refreshGridWithoutSelection,
  handleBulkRateCompletion,
  setHoldUntilDate,
  purchaseBulkOrders,
  downloadBulkOrderLabels,
  directPrintBulkOrderLabels,
  downloadBulkPackingSlip,
  directPrintBulkPackingSlip,
  printBulkPackingSlip,
  assignBulkFulfillmentPlanToUserFromOrdersGrid,
  optimisticAssignFulfillmentPlanToUserFromOrdersGrid,
  openFulfillmentPlanAssignmentModal,
  cancelBulkOrderEpic,
  bulkCancelJobComplete,
  openMarkAsPaidModal,
  openScanToSearchModal,
} from './store/orders/orders.epics';
import { updateDrawerOrdersAfterAddressValidation as updateDrawerOrdersAfterAddressValidationFromSelectedOrders } from './store/orders/selected-orders/orders.selected-orders.epics';
import { writePagingInfoToUrl, readPagingInfoFromUrl } from './store/paging/paging.epics';
import {
  purchasePostageInsuranceWalletFundsRequest,
  handlePostagePurchaseSuccessAndPostagePurchaseDeferred,
  closeOrderDetailsModalOnBillingInfoLinkClick,
} from './store/postage-purchase/postage-purchase.epics';
import { writePrintSettingsToLocalStorage, writePrintWarningSettingsToLocalStorage } from './store/print-settings/print-settings.epics';
import {
  printLabelFromFulfillmentPlanEpic,
  openPrintModal,
  openPrintModalForEndOfDayForm,
  closePrintModal,
  documentDownloadStarted,
  markPrinted,
  markLabelPrinted,
  markPackingSlipPrintedIfMatchingLabelHasBeenPrinted,
  markPackingSlipPrinted,
  markPickListPrinted,
  downloadPackingSlip,
  directPrintPackingSlip,
  printPackingSlip,
  downloadLabel,
  directPrintLabel,
  printLabel,
  printPickList,
  printCustomsForms,
  printHotkeysAndBarcode,
  validatePrintCustomsForms,
  printCustomsFormsForOrders,
  printEndOfDayForms,
  printReturnLabels,
  printShipmentManifest,
  printPurchaseOrder,
  printLocationBarcode,
  printUomBarcodes,
} from './store/printing/print.epics';
import { generateOrderSummary, printOrderSummary, printOrderSummaryFromShipmentsGrid } from './store/printing/print.order-summary.epics';
import {
  bulkLoadProductDataRequest,
  reloadUpdatedProductInformation,
  openProductDetailModal,
  onProductCreate,
  onProductUpdate,
  onApplyProductUpdatesToOpenFulfillmentPlansSuccess,
  getProducts,
  getProductProfilesSuccess,
  getProductCategoriesSuccess,
  addWarehouseToProducts,
  removeWarehouseFromProducts,
  updateProductWarehouseAssociations,
  addTagsToProducts,
  removeTagsFromProducts,
  exportProductsRequest,
  importProductsRequest,
  getProductImportLog as getProductImportLogFromProducts,
} from './store/products/products.epic';
import { exportPurchaseOrdersRequest } from './store/purchase-orders/purchase-orders.epic';
import { pusherSellerChannelSubscribed } from './store/pusher/pusher.epics';
import { openRateBrowserModal } from './store/rate-browser/rate-browser.epics';
import { loadRates, rateRecievedErrorPre, rateRecievedSuccessPre } from './store/rate-viewer/rate-viewer.epics';
import { getSellerSuccess } from './store/reference-data/reference-data.epics';
import { refreshTrackingFromReturnGridEpic, refreshTrackingFromShipmentsGridEpic } from './store/refresh-tracking/refresh-tracking.epics';
import { generateReportEpic } from './store/reports/reports.epic';
import {
  goToReturnDetails,
  getReturnDetailsEpic,
  refreshReturnDetailsEpic,
  openReturnDetailsModal,
  closeReturnDetailsModal,
  openSetReceivedDateModal,
} from './store/returns/details/returns.details.epics';
import { returnsViewsChanged } from './store/returns/nav/returns.nav.epics';
import {
  changePageEpic,
  getReturnsGridDataEpic,
  exportReturns,
  changeShipmentsUrl,
  openSetReceivedDateModal as openSetReceivedDateModalFromReturns,
  markAsReceived,
  refreshGrid as refreshGridFromReturns,
  openReturnLabelEmailModal,
  sendReturnLabelsToEmails,
  returnLabelEmailProcessedSuccessfully,
  returnLabelEmailProcessedFailure,
  saveGridConfigurationChanges,
  openCancelReturnLabelModalForGrid,
  openCancelReturnLabelModal,
  cancelAndVoidReturnShipment,
  cancelAndVoidReturnShipmentSuccess,
  cancelAndVoidReturnShipmentFailure,
  returnsQuickSearch,
  returnsSearchTermCount,
  downloadReturnLabel,
  printReturnLabelsFromGrid,
  createReturnLabel,
  createReturnLabelSuccess,
  bulkloadAdvancedSearchEntitiesEpic,
} from './store/returns/returns.epic';
import { returnsChangeView } from './store/returns/selected-returns/returns.selected-returns.epics';
import {
  letsBuyAndPrintSomeLabels,
  printExistingLabel,
  createLabel as createLabelFromS2P,
  useBulkToCreateLabelForScanToPrint,
  printDocumentRequest,
  handleErrorMessages,
  getFulfillmentsFromFulfillmentPlans,
} from './store/scan-to-print/s2p-purchase-and-print.epics';
import {
  redirectToShipmentDetails,
  setFulfillmentPlan,
  searchForFulfillmentPlan,
  searchBoxSearch,
  printHotkey,
  loadShipmentDetails,
  closingShipmentDetails,
  shipmentDetailsLoadFailure,
  setupCsw,
  popUpErrorToast,
  saveScanPrinterToLocalStorage,
  saveScanModeToLocalStorage,
  orderCannotBeShippedError,
  clearLeftoverToasts,
  initializeScanQueue,
  advanceScanQueue,
  autoAdvanceQueueOnWorkflowComplete,
  handleQueueOrderLoadFailure,
} from './store/scan-to-print/scan-to-print.epics';
import {
  deletePresetEpic,
  createOrSavePresetEpic,
  hotkeyApplyPresetEpic,
  updatePresetHotkeysEpic,
  closeEditModalEpic,
  presetReadScaleRequestEpic,
  callBackOnScaleRead,
} from './store/seller/presets/seller.presets.epics';
import {
  getSeller,
  getSellerLight,
  getSellerSuccess as getSellerSuccessFromSellerEpics,
  getAnnouncementsOnGetSellerSuccess,
  initializeImportNotificationsOnPusherReady,
  getWorkstationsRequest,
  refreshStoreRequest,
  refreshAllStoresRequest,
  getStoreErrorLog,
  handleMapRequestedServiceSuccess,
  refreshLabelProvidersRequest,
  refreshShippingServicesRequest,
  refreshServiceLevelsRequest,
  refreshPackagesRequest,
  refreshSellerWallets,
  promptSellerTermsAndConditionsEpic,
  acceptTermsAndConditionsEpic,
  startStampsAccountVerification,
  sellerProvidersUpdated,
  refreshStoreList,
  refreshPackingSlipTemplates,
  refreshDeliveryTemplates,
  refreshShipmentTemplates,
  refreshPlanAndSubscriptionInfo,
  handleProductImportNotifications,
  handleInventoryImportNotifications,
  refreshSelectedOrdersEpic,
  getSellerTotesEpic,
} from './store/seller/seller.epic';
import {
  sendNotificationsEpic,
  sendNotificationsError,
  sendNotificationsSuccess,
  retryNotificationsEpic,
} from './store/send-notifications/send-notifications.epics';
import { shipSalesOrdersTogether, handleGridCombineOrdersEpic } from './store/ship-together/ship-together.epic';
import { closeEODShipments } from './store/shipments/eod/shipments.eod.epics';
import {
  updateGridWithNoFilters as updateGridWithNoFiltersFromShipments,
  switchActiveFilterView as switchActiveFilterViewFromShipments,
  getSavedFilterViewsRequest as getSavedFilterViewsRequestFromShipments,
  saveNewFilterView as saveNewFilterViewFromShipments,
  saveExistingFilterView as saveExistingFilterViewFromShipments,
  updateSavedViewGridConfig as updateSavedViewGridConfigFromShipments,
  deleteFilterView as deleteFilterViewFromShipments,
  launchSaveShippingViewModal as launchSaveShippingViewModalFromShipments,
  launchEditShippingViewModal as launchEditShippingViewModalFromShipments,
  launchDeleteShippingViewModal as launchDeleteShippingViewModalFromShipments,
} from './store/shipments/filtering/shipments.filtering.epics';
import {
  sendShipmentNotification,
  refreshGrid as refreshGridFromShipments,
  changeOrderBy as changeOrderByFromShipments,
  downloadBulkPackingSlip as downloadBulkPackingSlipFromShipments,
  directPrintBulkPackingSlip as directPrintBulkPackingSlipFromShipments,
  printBulkPackingSlip as printBulkPackingSlipFromShipments,
  downloadBulkLabel,
  directPrintBulkLabel,
  printBulkLabel,
  setCustomColumnConfigurationOnFilterUpdate as setCustomColumnConfigurationOnFilterUpdateFromShipments,
  notifyMarketplace,
  updateAmazonShipmentNotifications,
} from './store/shipments/grid/shipments.grid.epics';
import {
  loadShipmentDetails as ShipmentDetails,
  goToShipmentDetailsForFulfillmentId,
  goToShipmentDetails,
  openShipmentDetailsFromLabelBatchStatusProcessingStep,
  openShipmentDetailsFromLabelBatchStatusModal,
  getShipmentDetailsEpic,
  refreshShipmentDetailsEpic,
  openShipmentDetailsModal,
  closeShipmentDetailsModal,
  persistShipmentConfigurationEpic,
  printShipmentLabelEpic,
  shipmentNotifyMarketplaces,
  clearShipFromCustomerDetailsTracker,
  closeCustomerDetailShipmentDetailsModal,
  validateShipmentDetailsShipToAddress,
  updateShipmentDetailsShipToAddress,
} from './store/shipments/shipment-details/shipments.details.epics';
import {
  getShipmentDataEpic,
  changeShipmentsPage,
  changeShipmentsUrl as changeShipmentsUrlFromShipments,
  assignBulkFulfillmentPlanToUser,
  scheduleUspsPickup,
  cancelUspsPickup,
} from './store/shipments/shipments.epics';
import {
  printDocumentRequest as printDocumentRequestFromSSConnect,
  printDocumentFailure,
  saveDefaultScaleToLocalStorage,
  restoreDefaultScale,
  handleWorkstationRemovedMessage,
  checkPusherChannels,
} from './store/shipstation-connect/ss-connect.epics';
import { openManageTagsModal, bulkAddFulfillmentPlanTags, bulkRemoveFulfillmentPlanTags } from './store/tags/tags.epics';
import { hydrateCurrentUser, getCurrentUser, saveUserSetting, saveUserGridConfig } from './store/user/user.epics';
import { redirectUserToV2, optOutWithoutFeedbackEpic } from './store/v3-opt-out/v3-opt-out.epics';
import { getProvidersEpic, disconnectProviderEpic } from './store/freight-settings/freight-settings.epics';
import { getShipmentsEpic, trackShipmentEpic, cancelShipmentEpic, downloadDocumentEpic } from './store/ltl/ltl.epics';
import { postWalletRegistrationSuccess } from './store/wallet/wallet.epic';

const allEpics = [
  // AccountInformationEpics
  getAccountInformationEpic,
  // AddressEpics
  validateAddressOrderDetails,
  updateOrderAfterAddressValidation,
  validateAddressSalesOrderShipToFailure,
  // FulfillmentPlanEpics
  updateFulfillmentPlanOrderGridStatus,
  // OrdersEpics
  updateShipTo,
  updateShipToAndSoldTo,
  // ScanToVerifyEpics
  getShipmentSuccess,
  verifyShipmentRequest,
  editVerifiedItems,
  setVerificationStatus,
  popUpVerificationToast,
  popUpVerificationErrorToast,
  // AdminEpics
  dropinEpic,
  endDropin,
  // AlertsEpics
  getMoreOrderAlertsEpic,
  // AlertDetailsEpics
  getAlertDetailsEpic,
  getShipTogetherOrdersEpicFromAlerts,
  // AlertsGridEpics
  alertsShipTogetherFetchEpic,
  respondToAlertsPageEvents,
  alertsDismissalEpic,
  getShipTogetherOrdersEpic,
  shipTogetherFromAlertsEpic,
  shipTogetherSuccessNotificationEpic,
  getOrdersForSelectedAlertsEpic,
  getOrdersForAlertSelectionEpic,
  // AlertsNavEpics
  ordersViewsChangedEpic,
  // AnnouncementsEpics
  getAnnouncments,
  displayNotificationsForAnnouncements,
  // AppHeaderEpics
  launchEnterpriseChat,
  // BatchesEpics
  createBatch,
  createBatchWithSalesOrdersRequest,
  addFulfillmentPlanOrSalesOrderToBatchRequest,
  saveBatchesEpic,
  cancelBatchEpic,
  saveBatchNameChange,
  createBatchWithFulfillmentPlanRequest,
  onCreateBatchWithSalesOrdersRequestSuccess,
  onCreateBatchWithFulfillmentPlansRequestSuccess,
  forceAddToBatch,
  onSalesOrderFulfillmentPlansRejectedFromBatchEpic,
  // BatchDetailsEpics
  getBatchDetailsEpic,
  validateBatchAddressesEpic,
  getBatchFulfillmentPlansForGridEpic,
  getBatchOrdersShipmentsMode,
  removedFulfillmentPlansFromBatchEpic,
  closeMoveToBatchModalEpic,
  batchValidationCompletedEpic,
  rateBatchCompletedEpic,
  rateOpenedOrderFromBatchEpic,
  sendShipmentNotificationsEpic,
  shipmentNotificationPusherMessageEpic,
  shipmentNotificationsSentSuccessfullyEpic,
  shipmentNotificationsSentFailureEpic,
  refreshBatchDetails,
  // BatchesGridEpics
  batchRowsGet,
  batchRowLoad,
  archiveBatches,
  validateBatchesAddressesEpic,
  sendEmailForBatchesEpic,
  sendNotificationsForBatchesEpic,
  updateSearchTermFromGridEpic,
  // LabelBatchModalStatusEpics
  getLabelQueBatchWarnAndError,
  handleGeneralLabelQueExceptionEpic,
  retryBatchForWarnAndErrorEpic,
  // BatchesNavEpics
  batchesUpdateShippingPageLeftNav,
  ordersViewsChanged,
  getBatchesMenuDataEpic,
  createLabelLastMessageBatchLoad,
  // BatchNoteEpics
  saveOrEditBatchNoteRequestEpic,
  // BatchesPrintEpics
  checkForLabelPrintedEpic,
  printLabelEpic,
  checkForPackingSlipPrintedEpic,
  printPackingSlipEpic,
  labelBatchPrintOtherForms,
  // BatchesPurchaseEpics
  startBatchesShipmentPurchase,
  // ScanToBatchEpics
  openScanToBatchModal,
  scanToBatchFulFillmentPlanSearch,
  addFulfillmentPlansToBatchFromScan,
  scannedOrderIsInAnotherBatch,
  unableToMoveOrderToBatch,
  scannedOrderWasNotFound,
  // BulkEpics
  createLabelProcessing,
  refreshOrdersGridAfterCreateLabel,
  // BulkCostReviewEpics
  costReviewModal,
  // BulkPrintEpics
  startBulkPurchaseFromPrint,
  startActiveLabelCheck,
  getLabelPrintedStatus,
  startPrintFlow,
  endBulkPrint,
  // BulkPurchaseEpics
  startBulkPurchase,
  // BulkReshipEpics
  bulkReshipStart,
  // BulkUpdateEpics
  onJobStarted,
  onJobStartedFromDrawer,
  onDoNotNotifyMarketPlaceJobStarted,
  // BulkVoidEpics
  startBulkVoid,
  showBulkVoidConfirmation,
  sendBulkVoidRequest,
  launchBulkVoidResultsModal,
  bulkVoidRetry,
  // BulkLoadEpics
  getFulfillmentPlansBulkloadData,
  getSalesOrdersBulkloadData,
  // BaseEpics
  appInitialization,
  initializePusher,
  // SellerRecommendationsEpics
  getSellerRecommendations,
  // CarrierSharingEpics
  getSharedServices,
  // CreateLabelContentEpics
  configureLabel,
  createLabel,
  endProcessingCreateLabel,
  createLabelFailure,
  // CSWEpics
  initCsw,
  createLabelFromCSW,
  createLabelFailureFromCSW,
  openPrintModalFromLabelSuccessEpic,
  changeInsuranceValue,
  getRateEpic,
  saveShippingConfigEpic,
  getBestWayToShip,
  changeServiceAndOtherShippingOptions,
  enterReturnsMode,
  enterExternalFulfillmentMode,
  createExternalFulfillment,
  showRateViewerErrors,
  createTestLabel,
  createTestLabelSuccess,
  saveShippingDropdownPreferenceToUserSettingsEpic,
  startUpdateAvailableShippingServices,
  fulfillmentPlannerGlobalListeners,
  cswCompareRates,
  // CustomerAutocompleteEpics
  customerSearchResultsEpic,
  // CustomersCombineEpics
  prepareToOpenCombineCustomersModal,
  prepareToOpenCombineCustomersConfirmationModal,
  combineCustomers,
  closeCombineCustomersConfirmationModal,
  reorderSelectedCustomers,
  // CustomersCreateLabelEpics
  launchCustomerCreateLabelModal,
  closeCustomerCreateLabelModal,
  // CustomersEpics
  addTagsToCustomers,
  refreshCustomers,
  removeTagsFromCustomers,
  getCustomersRequest,
  changeCustomersPage,
  quickSearchForCustomers,
  setCustomColumnConfigurationOnFilterUpdate,
  launchCustomerDetailModal,
  getCustomerPreviousOrders,
  clearCustomersSearch,
  launchCustomerMarketplacesModal,
  // CustomersFilteringEpics
  updateGridWithNoFilters,
  switchActiveFilterView,
  getSavedFilterViewsRequest,
  saveNewFilterView,
  saveExistingFilterView,
  updateSavedViewGridConfig,
  deleteFilterView,
  launchSaveShippingViewModal,
  launchEditShippingViewModal,
  launchDeleteShippingViewModal,
  // CustomersImportEpics
  prepareToOpenImportCustomersModal,
  startImport,
  afterImportSuccess,
  afterImportFailure,
  // CustomersNavEpics
  customersGridRefresh,
  // CustomsEpics
  checkCustomsStatusForOrders,
  checkCustomsStatusForFulfillmentPlans,
  // CustomsDeclarationsEpics
  validateAndSave,
  // Demos
  orderToursEpic,
  openExistingDemoOrderEpic,
  deactivateDemoOrderEpic,
  // DocumentsEpics
  printDocument,
  downloadDocument,
  // EntitiesEpics
  bulkFetchOrderDetails,
  updateFulfillmentPlanNote,
  unlockAddress,
  unlockAddressFailure,
  dismissFraudIndicator,
  // ErrorLoggingEpics
  logFailureEpicsToSenty,
  // ExportOrdersEpics
  openExportShipmentsModalEpic,
  initiateOrdersExportEpic,
  initiateOrdersCustomExportEpic,
  downloadOrdersExportEpic,
  // ExportShipmentsEpics
  openExportShipmentsModalEpicFromExportShipments,
  openExportBatchShipmentsModalEpic,
  initiateShipmentExportEpic,
  initiateBatchShipmentExportEpic,
  initiateShipmentsCustomExportEpic,
  downloadShipmentsExportEpic,
  // ExternalFulfillmentsEpics
  handleReceivedPusherMessage,
  onExportFulfillment,
  onExportFulfillmentExtended,
  onCustomExportFulfilments,
  // FillProvidersEpics
  getFillProviders,
  // HoldUntilEpics
  launchHoldUntilModal,
  launchRemoveHoldModal,
  // InventoryEpics
  getStockLevelDetails,
  getStockLevelDetailsOnGetOrderDetailsSuccess,
  getStockLevelDetailsOnShipFromChange,
  getStockLevelDetailsOnAllocationOrDeallocationSuccess,
  allocate,
  allocateFromOrderDetails,
  allocateFromShipmentDetails,
  allocateFromOrderDetailsCsw,
  allocateFromPrintModal,
  allocateSelectedFulfillmentPlansFromOrdersGrid,
  allocateFulfillmentPlansFailure,
  deallocate,
  deallocateSilently,
  deallocateOnShipFromChange,
  exportInventoryRequest,
  exportLocationsInventoryRequest,
  exportTotesRequest,
  importInventoryRequest,
  getProductImportLog,
  reloadInventoryGrid,
  // JobPipelineEpics
  startJobPipeline,
  runPipelineStepForJob,
  handleCurrentPipelineIndexChanged,
  exitPipeline,
  // LabelQueEpics
  getLabelQueBatchesEpic,
  labelQueArchiveBatches,
  getLabelQueBatchWarnAndErrorFromLabelQueue,
  beginLabelQueBatchPackingSlipPrintingEpic,
  beginBatchQueLabelPrintingEpic,
  labelQuePrintPickListEpic,
  labelQuePrintShipmentManifestEpic,
  labelQuePrintOrderSummaryEpic,
  handleGeneralLabelQueExceptionEpicFromLabelQueue,
  retryBatchForWarnAndErrorEpicFromLabelQueue,
  // LabelsEpics
  launchVoidModal,
  acceptWarningAndVoid,
  voidLabels,
  // MarkAsShippedEpics
  markAsShippedEpic,
  refreshGridAfterSuccessfullyMarkingOrdersOrShipmentsAsShipped,
  showThatAnErrorHappened,
  undoMarkAsShippedEpic,
  undoMarkAsShippedFromOrderDetails,
  undoMarkAsShippedSuccessEpic,
  // OneTimeScaleEpics
  oneTimeReadScaleRequestEpic,
  // OrdersDrawerEpics
  selectOrdersEpic,
  loadOrderDrawerEpic,
  clearDrawerErrorsAndWarnings,
  getDrawerOrdersEpic,
  validateAddress,
  updateDrawerOrdersAfterAddressValidation,
  refreshDrawer,
  bulkApplyRecommendations,
  // EditOrderEpics
  prepareToOpenNewOrderModal,
  openNewOrderModal,
  onChangesSaved,
  onSaveNewOrder,
  openCancelOrderModal,
  // OrdersFilteringEpics
  updateGridWithNoFiltersFromOrdersFilteringEpics,
  switchActiveFilterViewFromOrdersFilteringEpics,
  getSavedFilterViewsRequestFromOrdersFilteringEpics,
  saveNewFilterViewFromOrdersFilteringEpics,
  saveExistingFilterViewFromOrdersFilteringEpics,
  updateSavedViewGridConfigFromOrdersFilteringEpics,
  deleteFilterViewFromOrdersFilteringEpics,
  launchSaveOrdersViewModal,
  launchEditOrdersViewModal,
  launchDeleteOrdersViewModal,
  // OrdersGridEpics
  changeOrderBy,
  orderGridAddressValidation,
  openMarkShippedModal,
  setCustomColumnConfigurationOnFilterUpdateFromOrdersGridEpics,
  getRatesFromGridEpic,
  getRatesForGridRequestEpic,
  getRatesFromGridFailureEpic,
  addSalesOrderToBatchFromGridEpic,
  openAddSalesOrderToBatchFromGridEpic,
  saveDrawerVisbilityUserSetting,
  // OrdersImportEpics
  getMappings,
  openOrderImportMappingsModal,
  openMappingsDeleteModal,
  deleteSavedMapping,
  upload,
  afterUploadSuccess,
  openMappingsManagerModal,
  startFileImport,
  openImportProgressNotification,
  renameSavedMapping,
  afterStoreUpdate,
  afterImportLogSuccess,
  // OrdersNavEpics
  quickSearchFromScanToSearchEpic,
  ordersGetCountsEpic,
  // OrdersDetailsEpics
  getOrderDetailsEpic,
  getOrderDetailsSilentlyEpic,
  openOrderDetailsModal,
  closeOrderDetailsModal,
  refreshGridAndOrderDetailsAfterOrderUpdate,
  goToOrderDetails,
  setSelectedReturnItems,
  exitReturnsMode,
  makeCreateAnotherShipmentSucess,
  addSalesOrderToBatchEpic,
  updateOrderItemsRequest,
  updateOrderDetailsOrderItemsOnSuccess,
  // OrdersOrdersEpics
  getOrderDataEpic,
  changeOrdersPage,
  createOrderEpic,
  markAsPaidEpic,
  addTagsToFulfillmentPlans,
  removeTagsFromFulfillmentPlans,
  quickSearchForOrders,
  ordersSearchTermCount,
  restoreOrder,
  restoreFulfillments,
  clearGridSelections,
  refreshGrid,
  refreshGridWithoutSelection,
  handleBulkRateCompletion,
  setHoldUntilDate,
  purchaseBulkOrders,
  downloadBulkOrderLabels,
  directPrintBulkOrderLabels,
  downloadBulkPackingSlip,
  directPrintBulkPackingSlip,
  printBulkPackingSlip,
  assignBulkFulfillmentPlanToUserFromOrdersGrid,
  optimisticAssignFulfillmentPlanToUserFromOrdersGrid,
  openFulfillmentPlanAssignmentModal,
  cancelBulkOrderEpic,
  bulkCancelJobComplete,
  openMarkAsPaidModal,
  openScanToSearchModal,
  // SelectedOrdersEpics
  updateDrawerOrdersAfterAddressValidationFromSelectedOrders,
  // PagingEpics
  writePagingInfoToUrl,
  readPagingInfoFromUrl,
  // PostagePurchaseEpics
  purchasePostageInsuranceWalletFundsRequest,
  handlePostagePurchaseSuccessAndPostagePurchaseDeferred,
  closeOrderDetailsModalOnBillingInfoLinkClick,
  // PrintSettingsEpics
  writePrintSettingsToLocalStorage,
  writePrintWarningSettingsToLocalStorage,
  // PrintEpics
  printLabelFromFulfillmentPlanEpic,
  openPrintModal,
  openPrintModalForEndOfDayForm,
  closePrintModal,
  documentDownloadStarted,
  markPrinted,
  markLabelPrinted,
  markPackingSlipPrintedIfMatchingLabelHasBeenPrinted,
  markPackingSlipPrinted,
  markPickListPrinted,
  downloadPackingSlip,
  directPrintPackingSlip,
  printPackingSlip,
  downloadLabel,
  directPrintLabel,
  printLabel,
  printPickList,
  printCustomsForms,
  printHotkeysAndBarcode,
  validatePrintCustomsForms,
  printCustomsFormsForOrders,
  printEndOfDayForms,
  printReturnLabels,
  printShipmentManifest,
  // PrintOrderSummaryEpics
  generateOrderSummary,
  printOrderSummary,
  printOrderSummaryFromShipmentsGrid,
  // ProductsEpics
  bulkLoadProductDataRequest,
  reloadUpdatedProductInformation,
  openProductDetailModal,
  onProductCreate,
  onProductUpdate,
  onApplyProductUpdatesToOpenFulfillmentPlansSuccess,
  getProducts,
  getProductProfilesSuccess,
  getProductCategoriesSuccess,
  addWarehouseToProducts,
  removeWarehouseFromProducts,
  updateProductWarehouseAssociations,
  addTagsToProducts,
  removeTagsFromProducts,
  exportProductsRequest,
  importProductsRequest,
  getProductImportLogFromProducts,
  // PurchaseOrdersEpics
  exportPurchaseOrdersRequest,
  // PusherEpics
  pusherSellerChannelSubscribed,
  // RateBrowserEpics
  openRateBrowserModal,
  // RateViewerEpics
  loadRates,
  rateRecievedErrorPre,
  rateRecievedSuccessPre,
  // ReferenceDataEpics
  getSellerSuccess,
  // RefreshTrackingEpics
  refreshTrackingFromReturnGridEpic,
  refreshTrackingFromShipmentsGridEpic,
  // ReturnsDetailsEpics
  goToReturnDetails,
  getReturnDetailsEpic,
  refreshReturnDetailsEpic,
  openReturnDetailsModal,
  closeReturnDetailsModal,
  openSetReceivedDateModal,
  // ReturnsNavEpics
  returnsViewsChanged,
  // ReturnsEpics
  changePageEpic,
  getReturnsGridDataEpic,
  exportReturns,
  changeShipmentsUrl,
  openSetReceivedDateModalFromReturns,
  markAsReceived,
  refreshGridFromReturns,
  openReturnLabelEmailModal,
  sendReturnLabelsToEmails,
  returnLabelEmailProcessedSuccessfully,
  returnLabelEmailProcessedFailure,
  saveGridConfigurationChanges,
  openCancelReturnLabelModalForGrid,
  openCancelReturnLabelModal,
  cancelAndVoidReturnShipment,
  cancelAndVoidReturnShipmentSuccess,
  cancelAndVoidReturnShipmentFailure,
  returnsQuickSearch,
  returnsSearchTermCount,
  downloadReturnLabel,
  printReturnLabelsFromGrid,
  createReturnLabel,
  createReturnLabelSuccess,
  bulkloadAdvancedSearchEntitiesEpic,
  // SelectedReturnsEpics
  returnsChangeView,
  // S2PPurchaseAndPrintEpics
  letsBuyAndPrintSomeLabels,
  printExistingLabel,
  createLabelFromS2P,
  useBulkToCreateLabelForScanToPrint,
  printDocumentRequest,
  handleErrorMessages,
  getFulfillmentsFromFulfillmentPlans,
  // ScanToPrintEpics
  redirectToShipmentDetails,
  setFulfillmentPlan,
  searchForFulfillmentPlan,
  searchBoxSearch,
  printHotkey,
  loadShipmentDetails,
  closingShipmentDetails,
  shipmentDetailsLoadFailure,
  setupCsw,
  popUpErrorToast,
  saveScanPrinterToLocalStorage,
  saveScanModeToLocalStorage,
  orderCannotBeShippedError,
  clearLeftoverToasts,
  initializeScanQueue,
  advanceScanQueue,
  autoAdvanceQueueOnWorkflowComplete,
  handleQueueOrderLoadFailure,
  // SellerPresetEpics
  deletePresetEpic,
  createOrSavePresetEpic,
  hotkeyApplyPresetEpic,
  updatePresetHotkeysEpic,
  closeEditModalEpic,
  presetReadScaleRequestEpic,
  callBackOnScaleRead,
  // SellerEpics
  getSeller,
  getSellerLight,
  getSellerSuccessFromSellerEpics,
  getAnnouncementsOnGetSellerSuccess,
  initializeImportNotificationsOnPusherReady,
  getWorkstationsRequest,
  refreshStoreRequest,
  refreshAllStoresRequest,
  refreshSelectedOrdersEpic,
  getStoreErrorLog,
  handleMapRequestedServiceSuccess,
  refreshLabelProvidersRequest,
  refreshShippingServicesRequest,
  refreshServiceLevelsRequest,
  refreshPackagesRequest,
  refreshSellerWallets,
  promptSellerTermsAndConditionsEpic,
  acceptTermsAndConditionsEpic,
  startStampsAccountVerification,
  sellerProvidersUpdated,
  refreshStoreList,
  refreshPackingSlipTemplates,
  refreshDeliveryTemplates,
  refreshShipmentTemplates,
  refreshPlanAndSubscriptionInfo,
  handleProductImportNotifications,
  handleInventoryImportNotifications,
  getSellerTotesEpic,
  // SendNotificationsEpics
  sendNotificationsEpic,
  sendNotificationsError,
  sendNotificationsSuccess,
  retryNotificationsEpic,
  // ShipTogetherEpics
  shipSalesOrdersTogether,
  handleGridCombineOrdersEpic,
  // ShipmentsFilteringEpics
  updateGridWithNoFiltersFromShipments,
  switchActiveFilterViewFromShipments,
  getSavedFilterViewsRequestFromShipments,
  saveNewFilterViewFromShipments,
  saveExistingFilterViewFromShipments,
  updateSavedViewGridConfigFromShipments,
  deleteFilterViewFromShipments,
  launchSaveShippingViewModalFromShipments,
  launchEditShippingViewModalFromShipments,
  launchDeleteShippingViewModalFromShipments,
  // ShipmentsGridEpics
  sendShipmentNotification,
  refreshGridFromShipments,
  changeOrderByFromShipments,
  downloadBulkPackingSlipFromShipments,
  directPrintBulkPackingSlipFromShipments,
  printBulkPackingSlipFromShipments,
  downloadBulkLabel,
  directPrintBulkLabel,
  printBulkLabel,
  setCustomColumnConfigurationOnFilterUpdateFromShipments,
  notifyMarketplace,
  updateAmazonShipmentNotifications,
  // ShipmentDetailsEpics
  ShipmentDetails,
  goToShipmentDetailsForFulfillmentId,
  goToShipmentDetails,
  openShipmentDetailsFromLabelBatchStatusProcessingStep,
  openShipmentDetailsFromLabelBatchStatusModal,
  getShipmentDetailsEpic,
  refreshShipmentDetailsEpic,
  openShipmentDetailsModal,
  closeShipmentDetailsModal,
  persistShipmentConfigurationEpic,
  printShipmentLabelEpic,
  shipmentNotifyMarketplaces,
  clearShipFromCustomerDetailsTracker,
  closeCustomerDetailShipmentDetailsModal,
  validateShipmentDetailsShipToAddress,
  updateShipmentDetailsShipToAddress,
  // ShipmentsEpics
  getShipmentDataEpic,
  changeShipmentsPage,
  changeShipmentsUrlFromShipments,
  assignBulkFulfillmentPlanToUser,
  scheduleUspsPickup,
  cancelUspsPickup,
  closeEODShipments,
  // SSConnectEpics
  printDocumentRequestFromSSConnect,
  printDocumentFailure,
  saveDefaultScaleToLocalStorage,
  restoreDefaultScale,
  handleWorkstationRemovedMessage,
  checkPusherChannels,
  // TagEpics
  openManageTagsModal,
  bulkAddFulfillmentPlanTags,
  bulkRemoveFulfillmentPlanTags,
  // UserEpics
  hydrateCurrentUser,
  getCurrentUser,
  saveUserSetting,
  saveUserGridConfig,
  // V3OptOutEpics
  redirectUserToV2,
  optOutWithoutFeedbackEpic,
  // WalletEpics
  postWalletRegistrationSuccess,
  // TransactionHistoryEpics
  onExportTransactionHistoryExportRequest,
  generateReportEpic,
  notifyAboutFinishedImport,
  updatePusherWhenFeatureFlagsChange,
  printPurchaseOrder,
  printLocationBarcode,
  printUomBarcodes,
  // AdvanceShippingNoticeEpics
  syncProductsStart,
  // NotificationHubEpics
  persistNotificationEpic,
  fetchNotificationsEpic,
  markAsReadEpic,
  markAllAsReadEpic,
  // FreightSettingsEpics
  getProvidersEpic,
  disconnectProviderEpic,
  // LtlFreightEpics
  getShipmentsEpic,
  trackShipmentEpic,
  cancelShipmentEpic,
  downloadDocumentEpic,
  // SuppliesEpics
  // CustomsDocumentsEpics
  getCarrierDocumentCapabilitiesEpic,
  getOrderDocumentsEpic,
  uploadOrderDocumentEpic,
  deleteOrderDocumentEpic,

  getShipmentDocumentsEpic,
  uploadShipmentDocumentEpic,
  deleteShipmentDocumentEpic,
  sendShipmentDocumentsEpic,

  savePendingDocumentConfigEpic,
];

export const rootEpic = combineEpics(...allEpics);
